import * as ReactRedux from 'react-redux'
import {CommandCaller} from "../../../lib/commands"
import {Dispatch} from "redux"
import {onSave,actionCreators} from "./actions"
import {SubscriptionAppValueProps,SubscriptionAppCallbackProps,SubscriptionApp} from "./presentation"
import {Store} from "react-redux";

export type FieldType = 'name' | 'optional' | 'reason'
export type ErrorField = {
	fieldType:FieldType
	errorMessage:string
}

export type SubscriptionAppStore = {
	subscriptionId?:number
	name:string
	optional:boolean
	reason:string
	isSaving:boolean
	errorFields?:ErrorField[]
}

export const subscriptionAppInitialState:SubscriptionAppStore = {
	name: '',
	optional: true,
	reason: '',
	isSaving: false
}

type SubscriptionAppOwnProps = {
	store: Store<SubscriptionAppStore>
	ajaxPageUrl:string
	onClose:() => void
}

const subscriptionAppMapStateToProps = (store:SubscriptionAppStore, ownProps:SubscriptionAppOwnProps):SubscriptionAppValueProps =>
	({
		name: store.name,
		optional: store.optional,
		reason: store.reason,
		isSaving: store.isSaving,
		errorFields: store.errorFields
	})

const subscriptionAppMapDispatchToProps = (dispatch:(a: any) => void, ownProps:SubscriptionAppOwnProps):SubscriptionAppCallbackProps =>
	({
		nameOnChange: (newName) => dispatch(actionCreators.field.changeNameAction(newName)),
		optionalOnChange: (newOptional) => dispatch(actionCreators.field.changeOptionalAction(newOptional)),
		reasonOnChange: (newReason) => dispatch(actionCreators.field.changeReasonAction(newReason)),
		onClose: ownProps.onClose,
		onSave: () => dispatch(onSave(new CommandCaller(ownProps.ajaxPageUrl), ownProps.onClose)),
	})

export const SubscriptionAppContainer = ReactRedux.connect<SubscriptionAppValueProps, SubscriptionAppCallbackProps, SubscriptionAppOwnProps, SubscriptionAppStore>(
	subscriptionAppMapStateToProps,
	subscriptionAppMapDispatchToProps
)(SubscriptionApp)



// WEBPACK FOOTER //
// ./src/subscriptionmanager/module/subscription-list/app.ts